import moment from 'moment';

import { DATE_FORMAT } from '../../constants/shared';

const parseDateFormat = (value) => moment(value)
  .utcOffset(180, true)
  .format(DATE_FORMAT);

export default parseDateFormat;
